// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2o2su","head":"Table_head__2Z2Fp","col":"Table_col__12gxf"};